import ModalController from "../modal_controller"
import PackageController from "./package_controller"
import { isMobile } from "@/helpers/window_size"

export default class extends ModalController {
  static outlets = ["venue-package"]
  declare readonly venuePackageOutlet: PackageController

  bookPackage(): void {
    this.close()

    // On mobile, the modal is part of the browser navigation, so a delay is required
    // to allow the navigation to complete before opening the next modal.
    if (isMobile()) {
      window.setTimeout(() => {
        this.venuePackageOutlet.bookButtonClick()
      }, ModalController.FADE_IN_DURATION)
    } else {
      this.venuePackageOutlet.bookButtonClick()
    }
  }
}
